import { mergeDateAndTime } from '@occc-app/lib/date';

export const BUSINESS_HOURS_START = 8; // 8 AM
export const BUSINESS_HOURS_END = 21; // 9 PM

export const isOutsideBusinessHours = (
  publishAtDate?: Date | null,
  publishAtTime?: Date | null,
): boolean => {
  if (!publishAtDate || !publishAtTime) {
    return false;
  }

  const combined = mergeDateAndTime(publishAtDate, publishAtTime);
  const hours = combined.getHours();

  return hours < BUSINESS_HOURS_START || hours >= BUSINESS_HOURS_END;
};
